@if (hasDivider) {
  <rt-divider></rt-divider>
}
<div class="inner">
  <div class="actions">
    @if (hasOptionalActions) {
      <div class="actions__additional">
        <rt-group>
          <ng-content
            select="rt-button.optional, rt-button.optional, a[rt-button].optional"
          ></ng-content>
        </rt-group>
      </div>
    }
    <div class="actions__main">
      <rt-group>
        <ng-content
          select="rt-button:not(.optional), rt-button:not(.optional), a[rt-button]:not(.optional)"
        ></ng-content>
      </rt-group>
    </div>
  </div>
</div>
